export default {
    namespaced: true,
    state: {
        active: '', // 激活的router path
        collapse: false, // 菜单true为折叠
        nowdisc: '111',
        treeInfo: Object,
    },
    mutations: {
        // 变更激活路由
        modifyUrl(state: any, active: string) {
            state.active = active;
        },
        // 收缩带单
        toggle(state: any, status: boolean) {
            if (typeof status === 'boolean') {
                state.collapse = status;
            } else {
                state.collapse = !state.collapse;
            }
        },
        changeTop(state: any, disc: string) {
            state.nowdisc = disc;
        },
        setTreeInfo(state: any, value: any){
            state.treeInfo = value;
        }
    }
}